<template>
    <div v-if="thumbnail" class="ini-attachment"
         :class="{'ini-attachment--inpreview': thumbnail,'ini-attachment--not-image': !thumbnail}" @click.stop="click">
        <div class="ini-attachment-content" v-if="size"><span>{{ size }}</span></div>
        <div class="ini-attachment-content" v-if="name"><span>{{ name }}</span></div>
        <lightbox :nav="false" v-if="thumbnail" ref="lightBox" :images="[{src:thumbnail}]"
        >
            <template v-slot="{ image }">
                <img :src="image.src" :alt="image.caption"/>
            </template>
        </lightbox>
    </div>
    <span v-else>-</span>

</template>

<script>
    import IniAvatar from '@/components/Avatar'
    import Lightbox from '@/components/Lightbox';

    export default {
        components: {
            Lightbox
        },
        data() {
            return {
                thumbnail: ''
            }
        },

        props: {
            id: String,
            name: String,
            size: String,
            ext: String
        },

        methods: {
            attachmentClicked(attachment) {
                this.$emit('attachment-clicked', attachment)
            },
        },

        async mounted() {
            if (this.ext !== 'png' && this.ext !== 'jpeg' && this.ext !== 'jpg') {
                return ''
            }

            let response = await Api.download(this.id, true)
            if (!response) {
                return
            }

            let blob = new Blob([response])
            this.thumbnail = window.URL.createObjectURL(blob)
        },

        methods: {
            click(e) {
                if (e.target.className!=='lightbox-overlay' && e.target.className!=='close-item') {
                    if (this.thumbnail) {
                        this.$refs.lightBox.clickImage(0)
                    } else {
                        this.$emit('click')
                    }
                }


            },
        }
    }
</script>
<style lang="scss">@import "@/assets/scss/components/_attachment.scss";</style>